import { PromiseResolvers } from '@nutrien/minesight-utility-module';

import { State } from '../../State';

export function notIdle(state: State): PromiseResolvers<void> {
  return state.whenIdle || Promise.withResolvers<void>();
}
